import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BrandingService } from './branding.service';
import { ensureHomeData } from './feature-access';

const AF_SUPPLY_TYPE_ID = 1;

export const sendRequestsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const $branding = inject(BrandingService);

  if ($branding.sendRequestsEnabled()) {
    return true;
  }

  return router.parseUrl('/home');
};

export const ggmBrandGuard: CanActivateFn = () => {
  const router = inject(Router);
  const $branding = inject(BrandingService);

  if ($branding.isGGM()) {
    return true;
  }

  return router.parseUrl('/home');
};

export const ggmSimulationGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const $branding = inject(BrandingService);

  if (!$branding.isGGM()) {
    return router.parseUrl('/home');
  }

  const homeData = await ensureHomeData();
  const canSimulate =
    homeData?.hasBilling === true &&
    homeData.suppliers?.some((supplier) => supplier.id === AF_SUPPLY_TYPE_ID) === true;

  if (canSimulate) {
    return true;
  }

  return router.parseUrl('/home');
};
